import { CHERRY_SOFTWARE_LOGO } from './cherrySoftwareAssets';
import { CHERRY_DEV } from './cherryDevBrand';

export { CHERRY_SOFTWARE_LOGO };
export { CHERRY_DEV };

const BRAND_NAME = 'cherryDev';

export const CALENDLY_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CHERRY_SOFTWARE_CALENDLY_URL) ||
  '';

export const WHATSAPP_PHONE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_CHERRY_SOFTWARE_WHATSAPP_PHONE) ||
  '';

export const WHATSAPP_DEFAULT =
  `Hola, quiero agendar un diagnóstico técnico gratuito con ${BRAND_NAME} para evaluar mi proyecto de software.`;

export const PAGE_TITLE = `${BRAND_NAME} | Sistemas a medida Full Stack`;
export const PAGE_DESCRIPTION =
  `${BRAND_NAME}: ingeniería Full Stack para software contable, e-commerce de alta capacidad, agendamiento y automatización interna. Diagnóstico técnico gratuito.`;

export const hero = {
  brand: BRAND_NAME,
  title: 'Desarrollamos el sistema a medida que su empresa necesita para operar sin límites ni errores.',
  subtitle:
    'Ingeniería Full Stack especializada en software contable, e-commerce de alta capacidad y sistemas de automatización interna. Soluciones robustas y escalables de punta a punta, diseñadas para la lógica de su negocio.',
  cta: 'Solicitar Diagnóstico por WhatsApp',
  highlights: ['Software contable', 'E-commerce', 'Automatización', 'APIs'],
};

export const solutions = {
  overline: 'Catálogo de soluciones',
  title: 'Sistemas robustos diseñados para automatizar su operación',
  items: [
    {
      id: 'contable',
      title: 'Sistemas Contables y Administrativos',
      text:
        'Control total de inventarios, facturación, conciliaciones automáticas y visualización de datos en tiempo real para la toma de decisiones financieras.',
      icon: 'money',
      color: 'primary',
    },
    {
      id: 'ecommerce',
      title: 'E-commerce de Alta Capacidad',
      text:
        'Plataformas de venta en línea preparadas para alto tráfico, integradas a pasarelas de pago seguro y sincronizadas con su inventario central.',
      icon: 'web',
      color: 'secondary',
    },
    {
      id: 'agendamiento',
      title: 'Sistemas de Agendamiento y Reservas',
      text:
        'Automatización de citas, recordatorios automáticos para reducir ausencias y paneles de gestión optimizados para flujos operativos complejos.',
      icon: 'schedule',
      color: 'primary',
    },
    {
      id: 'integracion',
      title: 'Integración de Datos (APIs)',
      text:
        'Conectamos sus herramientas actuales para que dejen de duplicar tareas en Excel y toda la información fluya automáticamente.',
      icon: 'autorenew',
      color: 'secondary',
    },
  ],
};

export const painPoints = {
  overline: 'Impacto en el negocio',
  title: 'El software genérico frena el crecimiento de las empresas que escalan.',
  items: [
    {
      id: 'horas',
      title: 'Fuga de horas operativas',
      text:
        'Su equipo pierde horas duplicando datos manualmente en hojas de cálculo propensas a errores.',
      icon: 'schedule',
      color: 'secondary',
    },
    {
      id: 'sistemas',
      title: 'Sistemas aislados y sin comunicación',
      text:
        'Sus herramientas actuales no se conectan entre sí, creando cuellos de botella e islas de información.',
      icon: 'build',
      color: 'primary',
    },
    {
      id: 'licencias',
      title: 'Gasto ineficiente en licencias',
      text:
        'Paga suscripciones costosas por plataformas rígidas que solo aprovecha parcialmente porque no se adaptan a su flujo real.',
      icon: 'money',
      color: 'secondary',
    },
  ],
};

export const caseStudy = {
  overline: 'Prueba técnica',
  title: 'Casos de éxito con lógica empresarial compleja',
  subtitle: `Resúmenes ejecutivos de sistemas desarrollados a medida por ${BRAND_NAME}.`,
  item: {
    project: 'Sistema de Control Interno y Facturación',
    challenge:
      'El cliente requería centralizar operaciones complejas y automatizar flujos financieros en tiempo real.',
    solution:
      'Arquitectura Full Stack diseñada a medida con una base de datos optimizada para consistencia transaccional y un panel de administración intuitivo.',
    result:
      'Eliminación de errores manuales y reportes instantáneos listos para auditorías al cierre del mes.',
  },
};

export const workProcess = {
  overline: 'Nuestro proceso',
  title: 'Cómo funciona nuestro proceso',
  subtitle: 'Un flujo claro para reducir riesgo y garantizar que entienda lo que construimos.',
  steps: [
    {
      phase: 'Fase 1',
      title: 'Diagnóstico y Arquitectura',
      subtitle:
        'Analizamos los requerimientos, los flujos de datos y diseñamos la estructura lógica antes de escribir código.',
      icon: 'search',
    },
    {
      phase: 'Fase 2',
      title: 'Desarrollo e Integración',
      subtitle:
        'Construimos tanto el Backend (la lógica y seguridad del sistema) como el Frontend (la interfaz que usará su equipo).',
      icon: 'code',
    },
    {
      phase: 'Fase 3',
      title: 'Despliegue y Soporte',
      subtitle:
        'Lanzamos el sistema en entornos seguros y capacitamos a su personal para garantizar una transición exitosa.',
      icon: 'launch',
    },
  ],
};

export const conversion = {
  overline: 'WhatsApp',
  title: 'Agenda tu diagnóstico técnico por WhatsApp',
  subtitle:
    'Escríbenos ahora: evaluamos tus requerimientos en minutos y te orientamos sobre viabilidad y siguientes pasos.',
  bullets: [
    'Respuesta rápida por chat',
    'Diagnóstico técnico sin costo',
    'Sin formularios largos',
  ],
  submitCta: 'Escribir por WhatsApp ahora',
  copyright: `© ${BRAND_NAME} · Caracas, Venezuela. Todos los derechos reservados.`,
};
